'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface HubMapLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: HubMapLayoutProps) {
    return <ServiceLayout showFooter={false}>{children}</ServiceLayout>;
}
